import Plyr from 'plyr';
import {CookieModule} from './cookie.module';
import Cookies from 'js-cookie';
import {BaseModule} from './base.module';

export class VideoPlayerModule extends BaseModule {
    constructor(configuration = null) {
        super();
        this.videoSelector = '.player';
        this.configuration = {
            // iconUrl: './plyr.svg'
            storage: {
                enabled: false,
            },
            controls: function () {
                return [
                    'play-large',
                    'play',
                    'progress',
                    'current-time',
                    'mute',
                    'volume',
                    'captions',
                    'settings',
                    'pip',
                    'airplay',
                    'fullscreen'
                ]
            },
        };
        this.detectedVideoPlayerModuleInstances = [];
        if (configuration) {
            this.configuration = Object.assign(this.configuration, configuration);
        }
        if (typeof window !== 'undefined' && window.videoPlayerModuleConfiguration) {
            this.configuration = Object.assign(this.configuration, window.videoPlayerModuleConfiguration);
        }
    }

    setEventListeners() {
        window.addEventListener('CookiebotOnAccept', (event) => {
            if (Cookiebot.consent.marketing) {
                import('plyr').then((module) => {
                    let videos = document.querySelectorAll(this.videoSelector);
                    videos.forEach((video) => {
                        video.innerHTML = ``; // empty it
                        if (typeof video.dataset !== 'undefined') {
                            video.innerHTML = ``; // empty
                            let id = '#' + video.getAttribute('id');
                            let p = new module.default(id, this.configuration);
                            this.detectedVideoPlayerModuleInstances.push(p);
                        }
                    });
                    this.setVideoModalEventListeners();
                });
            }
        });
    }

    setVideoModalEventListeners() {
        // would stop video when closing modal
        // .video-modal
        let videoModals = document.querySelectorAll('.video-modal');
        videoModals.forEach((videoModal) => {
            let videosInModal = videoModal.querySelectorAll('.plyr');
            videosInModal.forEach((videoInModal) => {
                // get (video-)modals and add event listener for close
                videoModal.addEventListener('hidden.bs.modal', () => {
                    this.detectedVideoPlayerModuleInstances.forEach((detectedVideoPlayerModuleInstance) => {
                        detectedVideoPlayerModuleInstance.stop();
                    });
                });
                videoModal.addEventListener('shown.bs.modal', () => {
                    this.detectedVideoPlayerModuleInstances.forEach((detectedVideoPlayerModuleInstance) => {
                        // detectedVideoPlayerModuleInstance.focus();
                        detectedVideoPlayerModuleInstance.play();
                    });
                });

            });
        })
        // var videos = document.documentElement.querySelectorAll('.medium-zoom-video');
        // for (let i = 0; i < videos.length; i++) {
        //     var video = videos[i];
        //
        // }
    }

    /**
     *
     * @param {} videos
     * @param {Plyr} module
     */
    setVideoPlaceholders(videos, module, event) {
        console.log('setVideoPlaceholders', videos, module);
        videos.forEach((video) => {
            if (typeof video.dataset !== 'undefined') {
                console.log('found an embed that uses non-functional cookies', video);
                console.log('here is the data', event.data);
                let id = '#' + video.getAttribute('id')
                let configCopy = Object.assign({}, this.configuration);
                configCopy.controls = `
								<div class="plyr__controls">
									<button type="button" class="plyr__control plyr__controls__item" aria-label="Play, {title}" data-plyr="play">
										<svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg>
										<svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg>
										<span class="label--pressed plyr__tooltip" role="tooltip">Pause</span>
										<span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span>
									</button>
									<div class="plyr__controls__item plyr__progress__container custom-progress-container">
										<div class="plyr__controls__item plyr__progress">
											<input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek">
											<progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress>
											<span role="tooltip" class="plyr__tooltip">00:00</span>
										</div>
									</div>
									<div class="plyr__controls__item plyr__time plyr__time--current" aria-label="Current time">00:00</div>
									<div class="plyr__controls__item plyr__time plyr__time--duration" aria-label="Duration">00:00</div>
									<button type="button" class="plyr__control" aria-label="Mute" data-plyr="mute">
										<svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-muted"></use></svg>
										<svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-volume"></use></svg>
										<span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span>
										<span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span>
									</button>
									<div class="plyr__controls__item plyr__volume">
										<input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume">
									</div>
									<button type="button" class="plyr__controls__item plyr__control plyr__control--pressed youtube-caption-button-hidden" data-plyr="captions-youtube">
										<svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-settings"></use></svg>
										<svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-settings"></use></svg>
										<span class="label--pressed plyr__tooltip" role="tooltip">Disable captions</span>
										<span class="label--not-pressed plyr__tooltip" role="tooltip">Enable captions</span>
									</button>
									<button type="button" class="plyr__controls__item plyr__control" data-plyr="fullscreen">
										<svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-exit-fullscreen"></use></svg>
										<svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-enter-fullscreen"></use></svg>
										<span class="label--pressed plyr__tooltip" role="tooltip">Exit fullscreen</span>
										<span class="label--not-pressed plyr__tooltip" role="tooltip">Enter fullscreen</span>
									</button>
								</div>
								<button type="button" class="plyr__control plyr__control--overlaid" data-plyr="play" aria-pressed="false" aria-label="Play, Owl City - Fireflies (Official Music Video)"><svg aria-hidden="true" focusable="false"><use xlink:href="#plyr-play"></use></svg><span class="plyr__sr-only">Play</span></button>
								`
                let p = new module.default(id, configCopy);
                p.on('ready', (playerReadyEvent) => {
                    console.log('ready player', p, playerReadyEvent.target, playerReadyEvent);
                    if (p.provider == 'youtube' && typeof p.embed !== 'undefined') {
                        let youTubeCaptionControl = playerReadyEvent.target.querySelector('[data-plyr="captions-youtube"]');
                        console.log('youTubeCaptionControl', youTubeCaptionControl);
                        // console.log('embed defined', p.embed, p.embed.getOptions());
                        p.embed.addEventListener('onApiChange', (apiChangeEvent) => {
                            console.log('embed onApiChange event handler', apiChangeEvent);
                            let captionsOptions = p.embed.getOptions('captions');
                            // console.log('embed captions options', captionsOptions);
                            captionsOptions.forEach((captionOption) => {
                                // let option = p.embed.getOption('captions', captionOption);
                                if (captionOption == 'reload') {
                                    p.embed.setOption('captions', 'reload', true);
                                    let c = p.embed.getOption('captions', 'track');
                                    if (c) {
                                        playerReadyEvent.target.dataset.currentCaption = JSON.stringify(c);
                                        console.log('video...', video, c);
                                    }
                                    console.log('caption option', c);
                                }
                            });
                            if (captionsOptions && captionsOptions.length) {
                                if (youTubeCaptionControl) {
                                    youTubeCaptionControl.classList.remove('youtube-caption-button-hidden');
                                }
                            }
                        });

                        if (youTubeCaptionControl) {
                            youTubeCaptionControl.addEventListener('click', (youTubeCaptionControlClickEvent) => {
                                console.log('youTubeCaptionControl click event',
                                    youTubeCaptionControlClickEvent, youTubeCaptionControlClickEvent.target
                                );

                                switch (youTubeCaptionControl.classList.contains('plyr__control--pressed')) {
                                    case true:
                                        youTubeCaptionControl.classList.remove('plyr__control--pressed');
                                        p.embed.setOption('captions', 'track', {}); //unset
                                        break;
                                    case false:
                                        youTubeCaptionControl.classList.add('plyr__control--pressed');
                                        if (p && typeof p.embed !== 'undefined') {
                                            console.log('currentCaption', playerReadyEvent.target.dataset.currentCaption);
                                            p.embed.setOption('captions', 'track', JSON.parse(playerReadyEvent.target.dataset.currentCaption)); //unset
                                            p.embed.setOption('captions', 'reload', true); // actually load
                                        }
                                        break;
                                }
                            });
                        }

                    }
                });


            }
        });
    }

    initialize() {
        if (typeof document !== 'undefined') {
            this.setEventListeners();
        }
    }

    importPlayer(videos) {
        import('plyr').then((module) => {
            console.log('dynamically imported plyr module', module, '');
            videos.forEach((video) => {
                let id = '#' + video.getAttribute('id');
                let p = new module.default(id, this.configuration);
            });
        });
    }
} 